<template>
    <div class="top-breadcrumb">
        <a-breadcrumb>
            <a-breadcrumb-item>
                <router-link to="/index">
                    <a-icon type="home"/>
                </router-link>
            </a-breadcrumb-item>
            <a-breadcrumb-item v-for="(item, index) in list" :key="index">{{item}}</a-breadcrumb-item>
        </a-breadcrumb>
    </div>
</template>

<script>
export default {
    data() {
        return {
            list: []
        };
    },
    beforeMount() {
        let { params = {}, name } = this.$route;
        if (!name) return false;
        let pathName = name.replace(/\s+/g, "");
        let pathArr = pathName.split("-") || [];
        
        if (
            Array.isArray(pathArr) &&
            pathArr.length > 1 &&
            pathArr[pathArr.length - 1] == "mixAction"
        ) {
            pathArr.pop();
            switch (params["action"]) {
                case "add":
                    pathArr.push("新增");
                    break;
                case "edit":
                    pathArr.push("编辑");
                    break;
                case "detail":
                    pathArr.push("详情");
                    break;
                default:
                    break;
            }
        }
        this.list = pathArr;
    },
};
</script>

<style lang="less">
.top-breadcrumb {
    position: relative;
    padding: 0 16px;
    max-width:300px;
    height: 46px;
    width:auto;
    float: left;
    overflow: hidden;
    .ant-breadcrumb {
        line-height: 44px;
    }
    & * {
        color: #ccc;
    }
}
/* .top-breadcrumb::after {
    position: absolute;
    height: 14px;
    width: 1px;
    background-color: #999;
    left: 0px;
    top: 16px;
    content: "";
} */
</style>